import React from "react";
import FieldListFactory from "components/FieldListFactory";
import { useScrollToElement } from "utils/hooks/editor";

/**
 * Form: src/components/Form/Components/Disclaimer/index.jsx
 */
const DisclaimerFields = ({ name }) => {
  useScrollToElement(name);

  return (
    <div className="ph3">
      <FieldListFactory
        name={name}
        config={[
          {
            name: "label"
          },
          {
            name: "description"
          },
          {
            name: "value",
            placeholder: "Set a disclaimer"
          }
        ]}
      />
    </div>
  );
};

export default DisclaimerFields;
